export default __webpack_public_path__ + "static/media/bg-login.51f515a9.svg";